module.exports = __webpack_public_path__ + "static/media/okGreen.a38cb93a.svg";